import { render, staticRenderFns } from "./ProjectSummaryBoxHeader.vue?vue&type=template&id=c8987258"
import script from "./ProjectSummaryBoxHeader.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryBoxHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports